import { Icon, IconNames, Tooltip } from '@dixa/lib-shared-habla';
import { Channel } from 'lib-shared-types-channels';
import { Component } from 'react';


import { DashboardQueue } from '../../../../api/types';

import styles from './agents.module.scss';

interface AgentNumbersProps {
  icon: IconNames;
  tooltipInfix?: string;
  available?: number;
  online?: number;
}

export class AgentNumbers extends Component<AgentNumbersProps> {
  render() {
    const { icon, tooltipInfix, available, online } = this.props;

    return (
      <div className={styles.numbers}>
        <Icon className={styles.icon} name={icon} />

        <Tooltip content={`Available ${tooltipInfix} agents`} dark>
          <span>{available}</span>
        </Tooltip>

        {online !== null && (
          <>
            <span>/</span>
            <Tooltip content={`Online ${tooltipInfix} agents`} dark>
              <span>{online}</span>
            </Tooltip>
          </>
        )}
      </div>
    );
  }
}

interface AgentsProps {
  dashboardQueue: DashboardQueue;
}

/**
 * Configurations for channels to be displayed in the agents column of the
 * dashboard overview.
 */
export const CHANNELS_CONFIG: ReadonlyArray<{
  readonly channel: Channel;
  readonly icon: IconNames;
  readonly tooltipInfix: string;
}> = [
  {
    channel: 'pstn_phone',
    icon: 'phone',
    tooltipInfix: 'phone',
  },
  {
    channel: 'widget_chat',
    icon: 'chat',
    tooltipInfix: 'chat',
  },
  {
    channel: 'email',
    icon: 'mail',
    tooltipInfix: 'email and contact form',
  },
  {
    channel: 'facebook_messenger',
    icon: 'facebook-messenger',
    tooltipInfix: 'messaging',
  },
];

export class Agents extends Component<AgentsProps> {
  render() {
    const { available_agents, online_agents } = this.props.dashboardQueue;

    return (
      <div className={styles.channels}>
        {CHANNELS_CONFIG.map(({ channel, tooltipInfix, icon }) => {
          const online = online_agents[channel] ?? 0;
          const available = available_agents[channel] ?? 0;

          if (!online) {
            return null;
          }

          const agentNumberProps: AgentNumbersProps = {
            icon,
            tooltipInfix,
            available,
            online,
          };

          return <AgentNumbers key={channel} {...agentNumberProps} />;
        })}
      </div>
    );
  }
}
